module.exports = __webpack_public_path__ + "static/media/scventure.e852f8ff.jpg";